import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {sendCode} from '../../../services/auth';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const UseSendCode = () => {
  const navigate = useNavigate();
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: ISendCodePayload) => {
      return sendCode(payload);
    },
    onSuccess: (_, variables) => {
      navigate('/auth/confirmation', {
        state: {
          mobile: variables?.mobile,
        },
      });
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate};
};

export default UseSendCode;
